export const bloodTypes = [
  'A - factor (+)',
  'A - factor (-)',
  'AB - factor (+)',
  'AB - factor (-)',
  'B - factor (+)',
  'B - factor (-)',
  'O - factor (+)',
  'O - factor (-)',
]
